export default "__VITE_PUBLIC_ASSET__a1dab081__"